import * as St from './NavStep.styles';

export type NavStepProps = React.PropsWithChildren<{
  isCompleted?: boolean;
  isHighlighted?: boolean;
  isEnabled?: boolean;
  isCurrent?: boolean;
  className?: string;
  onClick?: () => void;
  beforeChildren?: React.ReactNode;
}>;

const NavStep = ({
  beforeChildren,
  children,
  isCompleted = false,
  isHighlighted,
  isEnabled: isEnabledProp = false,
  isCurrent = false,
  className,
  onClick,
}: NavStepProps) => {
  const isEnabled = isCompleted || isEnabledProp;

  return (
    <St.Container
      data-is-highlighted={isHighlighted ?? isCompleted}
      data-is-current={isCurrent}
      disabled={!isEnabled && !isCurrent}
      className={className}
      {...(isEnabled ? { onClick } : {})}
    >
      {beforeChildren}
      <St.Content>{children}</St.Content>
    </St.Container>
  );
};

export default NavStep;
